export const environment = {
  envName: 'release',
  production: false,
  apiUrl: 'https://api.impact.release.kiwa.dev/v2/',
  frontUrl: 'https://impact.release.kiwa.dev/',
  analyticsApiUrl: 'https://api.impact.release.kiwa.dev/v2/',
  impactAnalyticsApiUrl: 'https://analytics.release.kiwa.dev/api/',
  kmUrl: 'https://km.release.kiwa.dev/',
  demoAccountId: 1,
  allowedDomains: ['api.impact.release.kiwa.dev', 'api.km.dev.kiwa.dev', 'analytics.release.kiwa.dev'],
  disallowedDomains: [],
  googleMapsKey: 'AIzaSyANXjyEQwRSXKnQiiSuLoqA4k6e0oEs1II',
  oauthData: {
    microsoftOauth: {
      clientId: '830f8a4e-36e5-443f-923c-245e29bde96b',
      redirectUri: 'https://impact.release.kiwa.dev/microsoft-login',
      logoutRedirectUri: 'https://impact.release.kiwa.dev/microsoft-login',
      tenantId:  '52d58be5-69b4-421b-836e-b92dbe0b067d',
    }
  },
  amplitudeKey: '9c920136012a535adc1622fed41f5e20',
  mawBucket: 'https://s3.eu-west-1.amazonaws.com/kita-dev-processed.kiwaimpact.com/',
  lessSecureAnalytics: [],
  flexmonsterLicenseKey: 'Z7J3-XIDJ1L-0L0X47-25635E-1V431G-1Z0316-540432-4C2Z1T-0Z586M-6T1054-2W4569-3P2O4S',
};
